<template>
  <div class="backDiv">
    <el-form
      :model="userSignUpInfo"
      ref="submitSignUpForm"
      :rules="rules"
      label-width="126px"
    >
      <el-collapse v-model="activeNames">
        <el-collapse-item title="基本信息" name="1">
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="姓名" prop="Name">
                <el-input v-model="userSignUpInfo.Name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="性别" prop="Sex">
                <el-radio-group v-model="userSignUpInfo.Sex">
                  <el-radio label="男"></el-radio>
                  <el-radio label="女"></el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="身份证号" prop="IDCard">
                <el-input
                  ref="idcard"
                  v-model="userSignUpInfo.IDCard"
                  maxlength="18"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="所属区域">
                <el-cascader
                  clearable
                  v-model="userSignUpInfo.AreaInfoId"
                  :key="isRescourceShow1"
                  :options="areaInfoList"
                  placeholder="请选择所属区域"
                  width="100%"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="集团公司">
                <el-cascader
                  clearable
                  v-model="userSignUpInfo.CompanyGroupId"
                  :key="isRescourceShow2"
                  :options="companyGroupList"
                  :props="{ checkStrictly: true }"
                  placeholder="请选择集团公司"
                  :show-all-levels="false"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="车牌号码" prop="LicensePlate">
                <el-input
                  v-model="userSignUpInfo.LicensePlate"
                  placeholder="请填写车牌号码，没有车辆填无即可"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="文化程度" prop="EduLevel">
                <el-select
                  v-model="userSignUpInfo.EduLevel"
                  width="100%"
                  placeholder="请选择文化程度"
                >
                  <el-option label="初中毕业" value="初中毕业"></el-option>
                  <el-option label="技工学校毕业" value="技工学校毕业"></el-option>
                  <el-option label="中专毕业" value="中专毕业"></el-option>
                  <el-option label="高中毕业" value="高中毕业"></el-option>
                  <el-option label="职业高中毕业" value="职业高中毕业"></el-option>
                  <el-option label="专科毕业" value="专科毕业"></el-option>
                  <el-option label="大学毕业" value="大学毕业"></el-option>
                  <el-option label="研究生毕业" value="研究生毕业"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="所学专业" prop="EduSkill">
                <el-input v-model="userSignUpInfo.EduSkill"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="毕业院校" prop="School">
                <el-input v-model="userSignUpInfo.School"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="毕业时间" prop="FinishDateString">
                <el-date-picker
                  v-model="userSignUpInfo.FinishDateString"
                  type="date"
                  placeholder="请选择毕业时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="联系电话" prop="MobilePhone">
                <el-input v-model="userSignUpInfo.MobilePhone" maxlength="11"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="报名类型">
                <el-select
                  v-model="userSignUpInfo.IsPersonal"
                  placeholder="请选择报名类型"
                  @change="handleWorkSiteBind"
                >
                  <el-option label="企业" :value="false"></el-option>
                  <el-option
                    v-if="isShowPersonItem"
                    label="个人"
                    :value="true"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="通讯地址">
                <el-tooltip content="用于邮寄纸质发票" placement="top">
                  <el-input v-model="userSignUpInfo.PostalAddress"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="电子邮箱">
                <el-tooltip content="用于发送电子发票" placement="top">
                  <el-input v-model="userSignUpInfo.MailAddress"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col
              :span="8"
              v-if="currentPeriodInfo.PeriodClass != '初次领证'"
              class="pr-30"
            >
              <el-form-item label="初领日期" prop="FirstBookDateString">
                <el-date-picker
                  v-model="userSignUpInfo.FirstBookDateString"
                  type="date"
                  placeholder="请选择初领日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item title="任职信息" name="2">
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="人员类别" prop="MenTypeId">
                <el-select
                  clearable
                  v-model="userSignUpInfo.MenTypeId"
                  @change="menTypeChange"
                  placeholder="请选择人员类别"
                >
                  <el-option
                    v-for="item in menTypeList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item
                v-if="!isShowWorkTypeCustom"
                label="职务或工种"
                prop="WorkTypeId"
              >
                <el-select
                  clearable
                  v-model="userSignUpInfo.WorkTypeId"
                  placeholder="请选择职务或工种"
                >
                  <el-option
                    v-for="item in workTypeList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="isShowWorkTypeCustom"
                label="职务或工种"
                prop="WorkTypeCustomName"
              >
                <el-input v-model="userSignUpInfo.WorkTypeCustomName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item v-if="isShowWorkSite" label="工作单位" prop="WorkSite">
                <el-input ref="worksite" v-model="userSignUpInfo.WorkSite"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="相关职称">
                <el-select
                  v-model="userSignUpInfo.AboutTitle"
                  placeholder="请选择相关职称"
                >
                  <el-option label="初级" value="初级"></el-option>
                  <el-option label="中级" value="中级"></el-option>
                  <el-option label="高级及以上" value="高级及以上"></el-option>
                  <el-option label="其它" value="其它"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item label="技能等级">
                <el-select
                  v-model="userSignUpInfo.SkillLevel"
                  placeholder="请选择技能等级"
                >
                  <el-option label="初级工" value="初级工"></el-option>
                  <el-option label="中级工" value="中级工"></el-option>
                  <el-option label="高级工" value="高级工"></el-option>
                  <el-option label="技师" value="技师"></el-option>
                  <el-option label="高级技师" value="高级技师"></el-option>
                  <el-option label="其它" value="其它"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="pr-30">
              <el-form-item v-if="isShowWorkSite" label="任职日期">
                <el-date-picker
                  v-model="userSignUpInfo.DutyFromString"
                  type="date"
                  placeholder="请选择任职日期"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="工作年限">
                <el-input-number
                  v-model="userSignUpInfo.WorkYear"
                  :min="0"
                  label="请选择工作年限"
                ></el-input-number>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" class="pr-30">
              <el-form-item label="工作经历">
                <el-tooltip
                  content="包含时间、单位及担任职务，如：2018年11月至2019年6月在[单位名称]担任[职务]"
                  placement="top"
                >
                  <el-input
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    placeholder="请输入工作经历"
                    v-model="userSignUpInfo.WorkHistory"
                  >
                  </el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item
          v-if="currentPeriodInfo.IsNeedBill == true"
          title="开票信息"
          name="3"
        >
          <el-row>
            <el-col :span="8" class="pr-30">
              <el-form-item label="开票类型" prop="BillType">
                <el-select
                  ref="billType"
                  v-model="userSignUpInfo.BillType"
                  placeholder="请选择开票类型"
                >
                  <el-option label="普票" value="普票"></el-option>
                  <el-option label="专票" value="专票"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16" class="pr-30">
              <el-form-item label="开票信息" prop="BillDetail">
                <el-tooltip content="包含开票单位名称、纳税人识别号" placement="top">
                  <el-input
                    ref="billDetail"
                    type="textarea"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    placeholder="请输入开票信息"
                    v-model="userSignUpInfo.BillDetail"
                  >
                  </el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item
          v-if="
            currentPeriodInfo.AttachFileSettingList &&
            currentPeriodInfo.AttachFileSettingList.length > 0
          "
          title="报名附件"
          name="4"
        >
          <div
            class="uploadPannel"
            v-for="(item, index) in currentPeriodInfo.AttachFileSettingList"
            :key="item.id"
          >
            <el-tooltip
              class="item"
              effect="dark"
              :content="item.Describe + (item.IsOnly === false ? '（可上传多份）' : '')"
              placement="top-start"
            >
              <el-upload
                action="https://cr.apmem.com/Upload/UploadSignUpInfoAttachFile"
                list-type="picture-card"
                :ref="'upload' + index"
                :data="uploadAttach"
                :accept="item.AllowSuffix.replace(/\|/g, ',')"
                :before-upload="(file) => handleUploadBefore(file, item)"
                :on-success="handleUploadSuccess"
                :on-remove="handleUploadRemove"
                :on-preview="handleUploadPreview"
                :file-list="fileList[item.Id]"
              >
                <p class="uploadTip">
                  <i class="el-icon-plus uploadTipIcon"></i>
                  <span style="color: red">{{ item.IsMust ? "* " : "" }}</span>
                  {{ item.Name }}
                </p>
              </el-upload>
            </el-tooltip>
          </div>
        </el-collapse-item>
      </el-collapse>
      <el-row style="margin-top: 60px">
        <el-col :span="8" class="pr-30">
          <el-form-item label="备注信息">
            <el-input v-model="userSignUpInfo.BackMemo"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="pr-30">
          <el-form-item label="验证码" prop="CheckNum">
            <el-input
              v-model="userSignUpInfo.CheckNum"
              style="float: left; width: 120px"
            ></el-input>
            <img
              @click="getCodeImage"
              style="float: left; margin-top: 5px; cursor: pointer; margin-left: 10px"
              :src="codeImageUrl"
              alt
            />
          </el-form-item>
        </el-col>
        <el-col :span="8" class="pr-30">
          <el-button
            v-if="
              currentPeriodInfo.AttachFileSettingList &&
              currentPeriodInfo.AttachFileSettingList.length > 0
            "
            type="success"
            @click="isShowAttachSettingDialog = true"
            >报名所需材料</el-button
          >
        </el-col>
      </el-row>
    </el-form>
    <!--报名附件列表 begin-->
    <el-dialog
      :title="currentPeriodInfo.Name + ' - 报名所需材料'"
      :visible.sync="isShowAttachSettingDialog"
      width="1200px"
      append-to-body
    >
      <el-table
        :data="currentPeriodInfo.AttachFileSettingList"
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column type="index" width="50" align="center"></el-table-column>
        <el-table-column prop="Name" width="240" label="附件名称"></el-table-column>
        <el-table-column
          prop="IsMust"
          label="附件要求"
          width="80"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.IsMust === true ? 'primary' : 'success'"
              disable-transitions
              >{{ scope.row.IsMust ? "必要的" : "可选的" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="IsOnly"
          label="附件数量"
          width="120"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.IsOnly === true ? 'primary' : 'success'"
              disable-transitions
              >{{ scope.row.IsOnly ? "一份" : "一份或多份" }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="AllowSuffix"
          width="120"
          label="附件后缀"
        ></el-table-column>
        <el-table-column prop="Describe" label="描述信息"></el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="isShowAttachSettingDialog = false">确 定</el-button>
      </span>
    </el-dialog>
    <!--报名附件列表 end-->
    <!--报名附件预览 begin-->
    <el-dialog title="报名附件预览" :visible.sync="dialogPreviewVisible" append-to-body>
      <img width="100%" :src="dialogPreviewImageUrl" alt="" />
    </el-dialog>
    <!--报名附件预览 begin-->
  </div>
</template>

<script>
import {
  getToken,
  getMenTypeList,
  getAreaInfoList,
  getCompanyGroupList,
  getWorkTypeList,
  signUpByUser,
  removeSignUpAttachFile,
} from "../api/index.js";
export default {
  name: "SignUp",
  data() {
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的电子邮箱"));
        }
      }, 100);
    };
    return {
      activeNames: ["1", "2", "3", "4"],
      isRescourceShow1: 100,
      isRescourceShow2: 200,
      currentPeriodInfo: {},
      menTypeList: [],
      areaInfoList: [],
      companyGroupList: [],
      workTypeList: [],
      codeImageUrl: "",
      isShowAttachSettingDialog: false,
      isShowWorkTypeCustom: false,
      isFirstUpload: "need",
      uploadAttach: {
        AttachFileSettingId: "",
        IDCard: "",
        PeriodTypeId: "",
        PeriodInfoId: "",
        IsFirstUpload: "need",
      },
      signUpAttachFileList: [],
      fileList: {},
      uploadAccept: "",
      isShowWorkSite: true,
      isShowPersonItem: true,
      userSignUpInfo: {
        IsPersonal: false,
        IndustryInfoId: "",
        PeriodInfoId: "",
        AreaInfoId: "",
        CompanyGroupId: "",
        MenTypeId: "",
        MenTypeName: "",
        Name: "",
        Sex: "",
        IDCard: "",
        MobilePhone: "",
        EduLevel: "",
        EduSkill: "",
        School: "",
        FinishDateString: "",
        WorkSite: "",
        AboutTitle: "",
        SkillLevel: "",
        WorkYear: 0,
        WorkTypeId: "",
        WorkTypeName: "",
        WorkTypeCustomName: "",
        DutyFromString: "",
        LicensePlate: "",
        PostalAddress: "",
        MailAddress: "",
        WorkHistory: "",
        BillType: "",
        BillDetail: "单位名称：\r\n纳税人识别号：",
        BackMemo: "",
        FirstBookDateString: "",
        CheckNum: "",
        CheckNumToken: "",
      },
      rules: {
        MenTypeId: [{ required: true, message: "请选择人员类别", trigger: "change" }],
        AreaInfoId: [{ required: true, message: "请选择所属区域", trigger: "change" }],
        Name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Sex: [{ required: true, message: "请选择性别", trigger: "change" }],
        IDCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            min: 18,
            max: 18,
            message: "请输入正确的身份证号",
            trigger: "blur",
          },
        ],
        MobilePhone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "请输入正确的联系电话",
            trigger: "blur",
          },
        ],
        AboutTitle: [{ required: true, message: "请选择相关职称", trigger: "change" }],
        SkillLevel: [{ required: true, message: "请选择技能等级", trigger: "change" }],
        EduLevel: [{ required: true, message: "请选择文化程度", trigger: "change" }],
        EduSkill: [{ required: true, message: "请输入所学专业", trigger: "blur" }],
        School: [{ required: true, message: "请输入毕业院校", trigger: "blur" }],
        FinishDateString: [
          { required: true, message: "请选择毕业时间", trigger: "blur" },
        ],
        WorkSite: [{ required: true, message: "请输入工作单位", trigger: "blur" }],
        IsPersonal: [{ required: true, message: "请选择报名类型", trigger: "change" }],
        WorkTypeId: [{ required: true, message: "请选择职务或工种", trigger: "change" }],
        WorkTypeCustomName: [
          { required: true, message: "请输入职务或工种", trigger: "blur" },
        ],
        DutyFromString: [{ required: true, message: "请选择任职日期", trigger: "blur" }],
        LicensePlate: [{ required: true, message: "请输入车牌号码", trigger: "blur" }],
        WorkHistory: [{ required: true, message: "请输入工作经历", trigger: "blur" }],
        MailAddress: [
          {
            required: true,
            message: "请输入电子邮箱",
            validator: checkEmail,
            trigger: "blur",
          },
        ],
        BillType: [{ required: true, message: "请选择开票类型", trigger: "change" }],
        BillDetail: [{ required: true, message: "请输入开票信息", trigger: "blur" }],
        FirstBookDateString: [
          { required: true, message: "请选择初领日期", trigger: "blur" },
        ],
        CheckNum: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "请输入正确的验证码", trigger: "blur" },
        ],
      },
      //附件上传预览
      dialogPreviewImageUrl: "",
      dialogPreviewVisible: false,
    };
  },
  watch: {
    areaInfoList() {
      ++this.isRescourceShow1;
    },
    companyGroupList() {
      ++this.isRescourceShow2;
    },
  },
  methods: {
    //人员类别列表加载
    menTypeListLoad() {
      let _this = this;
      _this.menTypeList = [];
      let paramData = {
        industryInfoId: _this.userSignUpInfo.IndustryInfoId,
        periodTypeId: _this.currentPeriodInfo.PeriodTypeId,
      };
      getMenTypeList(paramData)
        .then((res) => {
          if (res.state == "success") {
            _this.menTypeList = res.data;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //人员类别筛选联动，职务或工种列表加载
    menTypeChange() {
      this.workTypeList = [];
      this.userSignUpInfo.WorkTypeId = "";
      if (this.userSignUpInfo.MenTypeId) {
        let _this = this;
        let queryParam = {
          menTypeId: _this.userSignUpInfo.MenTypeId,
        };
        getWorkTypeList(queryParam)
          .then((res) => {
            if (res.state == "success") {
              _this.workTypeList = res.data;
              if (res.data && res.data.length > 0) {
                _this.userSignUpInfo.WorkTypeCustomName = "";
                _this.isShowWorkTypeCustom = false;
              } else {
                _this.userSignUpInfo.WorkTypeId = "";
                _this.isShowWorkTypeCustom = true;
              }
            } else {
              _this.$message.error(res.message);
            }
          })
          .catch((error) => {
            _this.$message.error("网络连接失败，请稍后重试");
          });
      } else {
        this.userSignUpInfo.WorkTypeCustomName = "";
        this.isShowWorkTypeCustom = false;
      }
    },
    //所属区域列表加载
    areaInfoListLoad() {
      let _this = this;
      _this.areaInfoList = [];
      getAreaInfoList()
        .then((res) => {
          if (res.state == "success") {
            _this.areaInfoList = res.data;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //集团公司列表加载
    companyGroupListLoad() {
      let _this = this;
      _this.companyGroupList = [];
      getCompanyGroupList()
        .then((res) => {
          if (res.state == "success") {
            _this.companyGroupList = res.data;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //获取验证码
    getCodeImage() {
      let _this = this;
      getToken()
        .then((res) => {
          if (res.state == "success") {
            _this.userSignUpInfo.CheckNumToken = res.data;
            _this.codeImageUrl =
              "https://cr.apmem.com/App/GetAuthCode?token=" +
              _this.userSignUpInfo.CheckNumToken;
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //清空报名信息
    cleanData() {
      this.userSignUpInfo.AreaInfoId = "";
      this.userSignUpInfo.CompanyGroupId = "";
      this.userSignUpInfo.MenTypeId = "";
      this.userSignUpInfo.MenTypeName = "";
      this.userSignUpInfo.Name = "";
      this.userSignUpInfo.Sex = "";
      this.userSignUpInfo.IDCard = "";
      this.userSignUpInfo.MobilePhone = "";
      this.userSignUpInfo.EduLevel = "";
      this.userSignUpInfo.EduSkill = "";
      this.userSignUpInfo.School = "";
      this.userSignUpInfo.FinishDateString = "";
      this.userSignUpInfo.FirstBookDateString = "";
      this.userSignUpInfo.WorkSite = "";
      this.userSignUpInfo.AboutTitle = "";
      this.userSignUpInfo.SkillLevel = "";
      this.userSignUpInfo.WorkYear = 0;
      this.userSignUpInfo.WorkTypeId = "";
      this.userSignUpInfo.WorkTypeName = "";
      this.userSignUpInfo.WorkTypeCustomName = "";
      this.userSignUpInfo.DutyFromString = "";
      this.userSignUpInfo.WorkHistory = "";
      this.userSignUpInfo.CheckNum = "";
      this.userSignUpInfo.BackMemo = "";
      this.userSignUpInfo.BillType = "";
      this.userSignUpInfo.BillDetail = "单位名称：\r\n纳税人识别号：";
      this.userSignUpInfo.MailAddress = "";
      this.uploadAttach.AttachFileSettingId = "";
      this.uploadAttach.IDCard = "";
      this.uploadAttach.PeriodTypeId = "";
      this.uploadAttach.PeriodInfoId = "";
      this.uploadAttach.IsFirstUpload = "need";
      this.isFirstUpload = "need";
      this.fileList = {};
      this.signUpAttachFileList = [];
      this.getCodeImage();
    },
    //提交报名信息
    submiteSignUp() {
      let _this = this;
      this.$refs["submitSignUpForm"].validate((valid) => {
        if (valid) {
          //判断工作单位是否填写
          if (
            _this.userSignUpInfo.IsPersonal == false &&
            !_this.userSignUpInfo.WorkSite
          ) {
            _this.$refs["worksite"].focus();
            _this.$message.error("请填写工作单位");
            return false;
          }
          //判断发票信息是否完整填写
          if (_this.currentPeriodInfo.IsNeedBill == true) {
            if (!_this.userSignUpInfo.BillType) {
              _this.$refs["billType"].focus();
              _this.$message.error("请选择开票类型");
              return false;
            }
            if (
              !_this.userSignUpInfo.BillDetail ||
              _this.userSignUpInfo.BillDetail.indexOf("单位名称：") == -1 ||
              _this.userSignUpInfo.BillDetail.indexOf("纳税人识别号：") == -1
            ) {
              _this.$refs["billDetail"].focus();
              _this.$message.error("请详细填写开票信息");
              return false;
            }
          }
          //判断初领日期是否填写
          if (
            _this.currentPeriodInfo.PeriodClass != "初次领证" &&
            !_this.userSignUpInfo.FirstBookDateString
          ) {
            _this.$message.error("请选择初领日期");
            return false;
          }
          //验证附件是否ok
          let errorMessage = "";
          _this.currentPeriodInfo.AttachFileSettingList.forEach((item) => {
            if (item.IsMust === true) {
              //判断是否已上传
              let isExist = false;
              _this.signUpAttachFileList.forEach((itemUpload) => {
                if (item.Id === itemUpload.AttachFileSettingId) {
                  isExist = true;
                }
              });
              if (!errorMessage && isExist === false) {
                errorMessage = item.Name + "未上传";
              }
            }
          });
          if (errorMessage) {
            _this.$message.error(errorMessage);
            return false;
          }
          //为报名回执赋值人员类别名称
          _this.menTypeList.forEach((item) => {
            if (item.Id == _this.userSignUpInfo.MenTypeId) {
              _this.userSignUpInfo.MenTypeName = item.Name;
            }
          });
          //为报名回执赋值从事职务名称
          if (_this.workTypeList && _this.workTypeList.length > 0) {
            _this.workTypeList.forEach((item) => {
              if (item.Id == _this.userSignUpInfo.WorkTypeId) {
                _this.userSignUpInfo.WorkTypeName = item.Name;
              }
            });
          }
          //赋值默认的日期信息
          if (!_this.userSignUpInfo.FinishDateString) {
            _this.userSignUpInfo.FinishDateString = "1900-01-01";
          }
          if (!_this.userSignUpInfo.DutyFromString) {
            _this.userSignUpInfo.DutyFromString = "1900-01-01";
          }
          if (!_this.userSignUpInfo.FirstBookDateString) {
            _this.userSignUpInfo.FirstBookDateString = "1900-01-01";
          }
          let paramData = {};
          for (let attr in _this.userSignUpInfo) {
            if (
              (attr.toString() == "AreaInfoId" || attr.toString() == "CompanyGroupId") &&
              _this.userSignUpInfo[attr] &&
              _this.userSignUpInfo[attr].length > 0
            ) {
              paramData[attr] =
                _this.userSignUpInfo[attr][_this.userSignUpInfo[attr].length - 1];
            } else {
              paramData[attr] = _this.userSignUpInfo[attr];
            }
          }
          _this
            .$confirm("请确认您的报名信息，提交后无法再次更改！", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              signUpByUser(paramData)
                .then((res) => {
                  if (res.state == "success") {
                    _this.cleanData();
                    _this.$message.success(res.message);
                    //关闭父级报名窗口
                    _this.$emit("colseParentSignUpDialog");
                    //判断是否打印报名回执单
                    if (_this.currentPeriodInfo.IsPrintReceipt == true) {
                      localStorage.setItem(
                        "printReceiptBookData",
                        JSON.stringify(paramData)
                      );
                      const { href } = _this.$router.resolve({
                        name: "ReceiptBook",
                      });
                      window.open(href, "_blank");
                    }
                  } else {
                    _this.userSignUpInfo.CheckNum = "";
                    _this.getCodeImage();
                    _this.$message.error(res.message);
                  }
                })
                .catch((error) => {
                  _this.userSignUpInfo.CheckNum = "";
                  _this.getCodeImage();
                  _this.$message.error("网络连接失败，请稍后重试");
                });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //父级页面选择期次信息
    changePeriodInfo() {
      let cacheData = localStorage.getItem("currentPeriodInfo");
      if (cacheData) {
        this.currentPeriodInfo = JSON.parse(cacheData);
        this.isShowPersonItem = this.currentPeriodInfo.IsAllowPerson;
        this.userSignUpInfo.IndustryInfoId = this.currentPeriodInfo.IndustryInfoId;
        this.userSignUpInfo.PeriodInfoId = this.currentPeriodInfo.Id;
        //绑定页面下拉数据
        this.menTypeListLoad();
        this.areaInfoListLoad();
        this.companyGroupListLoad();
      }
      this.getCodeImage();
    },
    //判断附件是否已经ok
    judgeAttachIsMatch() {
      let that = this;
      let errorMessage = "";
      this.currentPeriodInfo.AttachFileSettingList.forEach((item) => {
        if (item.IsMust === true) {
          //判断是否已上传
          let isExist = false;
          that.signUpAttachFileList.forEach((itemUpload) => {
            if (item.Id === itemUpload.AttachFileSettingId) {
              isExist = true;
            }
          });
          if (!errorMessage && isExist === false) {
            errorMessage = item.Name + "未上传";
          }
        }
      });
      if (errorMessage) {
        this.$message.error(errorMessage);
        return false;
      }
    },
    //附件上传前参数校验
    handleUploadBefore(file, fileAttachItem) {
      if (!this.userSignUpInfo.IDCard || this.userSignUpInfo.IDCard.length != 18) {
        this.$refs["idcard"].focus();
        this.$message.error("请先填写正确的身份证号，再上传报名附件");
        return false;
      }
      //判断附件是否符合要求，是否多传、文件大小是否符合要求
      let errorMessage = "";
      let that = this;
      this.currentPeriodInfo.AttachFileSettingList.forEach((item) => {
        if (item.Id === fileAttachItem.Id) {
          if (item.IsOnly === true) {
            //判断是否已上传
            that.signUpAttachFileList.forEach((itemUpload) => {
              if (item.Id === itemUpload.AttachFileSettingId) {
                errorMessage = item.Name + "只允许上传一份";
              }
            });
          }
          if (item.FileMinSize > 0 && file.size / 1024 < item.FileMinSize) {
            errorMessage = "附件大小不能小于" + item.FileMinSize + "KB";
          }
          if (item.FileMaxSize > 0 && file.size / 1024 > item.FileMaxSize) {
            errorMessage = "附件大小不能大于" + item.FileMaxSize + "KB";
          }
        }
      });
      if (errorMessage) {
        this.$message.error(errorMessage);
        return false;
      }
      //赋值上传参数信息
      this.uploadAttach.AttachFileSettingId = fileAttachItem.Id;
      this.uploadAttach.IDCard = this.userSignUpInfo.IDCard;
      this.uploadAttach.PeriodTypeId = this.currentPeriodInfo.PeriodTypeId;
      this.uploadAttach.PeriodInfoId = this.currentPeriodInfo.Id;
      this.uploadAttach.IsFirstUpload = this.isFirstUpload;
    },
    //附件上传成功插入结果列表
    handleUploadSuccess(response, file, fileList) {
      if (!response.data) {
        fileList.pop();
        this.$message.error(response.message);
        return false;
      }
      let fileName = file.name.toLowerCase();
      if (
        fileName.indexOf("jpeg") === -1 &&
        fileName.indexOf("jpg") === -1 &&
        fileName.indexOf("png") === -1 &&
        fileName.indexOf("gif") === -1
      ) {
        fileList[fileList.length - 1].url =
          "https://cr.apmem.com/Content/img/favicon.png";
      }
      this.isFirstUpload = "";
      this.signUpAttachFileList.push(response.data);
      //console.log(this.signUpAttachFileList);
    },
    //附件上传结果列表移除
    handleUploadRemove(file, fileList) {
      let fileId = file.response.data.Id;
      let postParam = {
        Id: fileId,
        PeriodInfoId: this.currentPeriodInfo.Id,
        IDCard: this.userSignUpInfo.IDCard,
      };
      let _this = this;
      removeSignUpAttachFile(postParam)
        .then((res) => {
          if (res.state == "success") {
            //移除已上传列表中的附件信息
            let removeIndex = -1;
            _this.signUpAttachFileList.forEach((itemFile, index) => {
              if (itemFile.Id === postParam.Id) {
                removeIndex = index;
              }
            });
            if (removeIndex > -1) {
              _this.signUpAttachFileList.splice(removeIndex, 1);
            }
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //附件上传结果预览
    handleUploadPreview(file) {
      this.dialogPreviewImageUrl = file.url;
      this.dialogPreviewVisible = true;
    },
    //报名类型联动工作单位
    handleWorkSiteBind() {
      this.userSignUpInfo.WorkSite = "";
      this.userSignUpInfo.DutyFromString = "";
      if (this.userSignUpInfo.IsPersonal == true) {
        this.isShowWorkSite = false;
      } else {
        this.isShowWorkSite = true;
      }
    },
    //页面数据绑定
    bindPageData() {
      let cacheData = localStorage.getItem("querySignUpHistoryData");
      if (cacheData) {
        let querySignUpHistoryData = JSON.parse(cacheData);
        console.log(querySignUpHistoryData);
        setTimeout(() => {
          this.userSignUpInfo.AboutTitle = querySignUpHistoryData.AboutTitle;
          this.userSignUpInfo.AreaInfoId = querySignUpHistoryData.AreaInfoId;
          this.userSignUpInfo.BillDetail = querySignUpHistoryData.BillDetail;
          this.userSignUpInfo.BillType = querySignUpHistoryData.BillType;
          this.userSignUpInfo.CompanyGroupId = querySignUpHistoryData.CompanyGroupId;
          this.userSignUpInfo.DutyFromString = querySignUpHistoryData.DutyFromString;
          this.userSignUpInfo.EduLevel = querySignUpHistoryData.EduLevel;
          this.userSignUpInfo.EduSkill = querySignUpHistoryData.EduSkill;
          this.userSignUpInfo.FinishDateString = querySignUpHistoryData.FinishDateString;
          this.userSignUpInfo.FirstBookDateString =
            querySignUpHistoryData.FirstBookDateString;
          this.userSignUpInfo.IDCard = querySignUpHistoryData.IDCard;
          this.userSignUpInfo.IndustryInfoId = querySignUpHistoryData.IndustryInfoId;
          this.userSignUpInfo.IsPersonal = querySignUpHistoryData.IsPersonal;
          this.userSignUpInfo.LicensePlate = querySignUpHistoryData.LicensePlate;
          this.userSignUpInfo.MailAddress = querySignUpHistoryData.MailAddress;
          this.userSignUpInfo.MobilePhone = querySignUpHistoryData.MobilePhone;
          this.userSignUpInfo.Name = querySignUpHistoryData.Name;
          this.userSignUpInfo.PostalAddress = querySignUpHistoryData.PostalAddress;
          this.userSignUpInfo.School = querySignUpHistoryData.School;
          this.userSignUpInfo.Sex = querySignUpHistoryData.Sex;
          this.userSignUpInfo.SkillLevel = querySignUpHistoryData.SkillLevel;
          this.userSignUpInfo.WorkHistory = querySignUpHistoryData.WorkHistory;
          this.userSignUpInfo.WorkSite = querySignUpHistoryData.WorkSite;
          this.userSignUpInfo.WorkYear = querySignUpHistoryData.WorkYear;
        }, 500);
      }
    },
  },
  activated() {},
  created() {
    this.bindPageData();
  },
};
</script>
<style scoped>
.backDiv {
  background-color: #fff;
  padding: 20px;
  text-align: left;
}

.pr-30 {
  padding-right: 30px;
}

.pt-40 {
  padding-top: 40px;
}

.pd-20 {
  padding: 20px;
}

.el-form .el-cascader {
  width: 100%;
}

.el-form .el-select {
  width: 100%;
}

.el-form .el-date-editor {
  width: 100%;
}

.el-form .el-input-number {
  width: 100%;
}

.uploadPannel {
  float: left;
  margin: 5px 5px 10px 5px;
}

.uploadTip {
  line-height: 32px;
  padding: 15px 5px 0 5px;
}

.uploadTip .uploadTipIcon {
  display: block;
  margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/SignUp.vue